import { Message } from "@apis:message/message";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Box } from "@mui/material";
import { AIResponse } from "@pages:app/talk/shared/AIResponse";

interface BotMessageProps {
  showReferences: boolean;
  text: string;
  references: Message["GET_ONE"]["Response"]["docs"];
  setShowReferences: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
  messageId: string | null | undefined;
}

export const BotMessage = ({
  showReferences,
  setShowReferences,
  text,
  references,
  messageId,
}: BotMessageProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          left: "-3rem",
        }}
      >
        <SVGInternalIcon
          icon="botNav"
          sx={{
            width: 30,
            height: 30,
            backgroundColor: "#F0FAFA",
            boxShadow: "0px 8px 24px 0px #1DA5AB29",
            "& .eye": {
              fill: "#1FADB2",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: "#F0FAFA",
          borderRadius: "30px",
          padding: "1rem 2rem",
          borderBottomLeftRadius: showReferences ? "0" : "30px",
          width: "100%",
        }}
      >
        <AIResponse
          answer={text}
          references={references}
          setShowReferences={setShowReferences}
          showReferences={showReferences}
          messageId={messageId}
        />
      </Box>
    </Box>
  );
};
